<script>
export default {
  props: {
    affiliate: {
      type: Object,
      required: true,
    },
    bundle: {
      type: Object,
      required: true,
    },
  },
  i18n: {
    messages: {
      fr: {
        commission_for_pack: 'Commission pour ce pack :',
        click_to_copy: 'cliquez pour copier',
        copy_link: 'Copier le lien',
      },
      en: {
        commission_for_pack: 'Commission for this bundle:',
        click_to_copy: 'click to copy',
        copy_link: 'Copy link',
      },
    },
  },
  computed: {
    url() {
      const { location } = window;
      const { code } = this.affiliate;
      const url = `${location.protocol}//${location.hostname}`;
      const prefix = this.$constants.AFFILIATE_PREFIX;
      const { href } = this.$router.resolve({
        name: 'bundle',
        params: { slug: this.bundle.slug },
      });

      return `${url}${href}?${prefix}${code}`;
    },
  },
};
</script>

<template>
  <article class="box">
    <div class="columns is-vcentered">
      <div class="column">
        <h2 class="title is-5 mb-3">
          {{ bundle.name }}
        </h2>
        <p class="mb-2">
          <b-icon icon="coins" />
          {{ $t('commission_for_pack') }} {{ bundle.commissionRate }}
        </p>
        <a
          class="color-inherit break-words"
          :href="url"
          v-clipboard:copy="url"
          v-clipboard:success="() => $copySuccess()"
          v-clipboard:error="() => $copyError()"
          @click.prevent
        >
          <b-tooltip :label="$t('click_to_copy')">
            <b-icon icon="clipboard" />
          </b-tooltip>
          {{ url }}
        </a>
      </div>
      <div class="column is-narrow">
        <b-button
          type="is-primary is-custom"
          v-clipboard:copy="url"
          v-clipboard:success="() => $copySuccess()"
          v-clipboard:error="() => $copyError()"
        >
          {{ $t('copy_link') }}
        </b-button>
      </div>
    </div>
  </article>
</template>
